<script lang="ts">
	import { SystemScreenBreakpoints } from '@Shelly/shelly-design-system/helpers/enums';
	import { Col, Row, Text } from '@Shelly/shelly-design-system/index';
	import LottiePlayer from 'src/components/LottiePlayer/LottiePlayer.svelte';

	export let description: string;
	export let src: string;

	let windowClientWidth: number;

	$: isMobile = windowClientWidth < SystemScreenBreakpoints.MOBILE_MAX;
	$: lottieWidth = isMobile ? 350 : 590;
	const HOMES_ONBOARDING_LOTTIE_ASPECT = 216 / 455;
	$: lottieHeight = Math.round(lottieWidth * HOMES_ONBOARDING_LOTTIE_ASPECT);
</script>

<svelte:window bind:innerWidth={windowClientWidth} />

<div class="step-content">
	<Row class="d-flex justify-content-between align-items-center">
		<Col sm="12" md="12" lg="12">
			<Text class="mb-m">{description}</Text>
		</Col>

		<LottiePlayer
			{src}
			width={lottieWidth}
			height={lottieHeight}
			showPreviewLabel={false}
			autoplay
			loop
		/>
	</Row>
</div>
